export const GA_EVENTS = Object.freeze({
  START: 'Appointment Start',
  CANCEL: 'Appointment Cancel',
  CONFIRM: 'Appointment Confirm',
  LOAD: 'Appointment Load',
  REVIEW: 'Appointment Review',
  SERVICES: 'Appointment Services',
  TIME: 'Appointment Time',
  VEHICLE: 'Appointment Vehicle'
});

export const GA_STATUS_TRACKER_EVENTS = Object.freeze({
  START: 'Status Tracker: Load',
  ERROR: 'Status Tracker: Error',
  DISABLED: 'Status Tracker: Disabled'
});



// WEBPACK FOOTER //
// ./src/constants/ga.js